//AMBIENTES - local, test, produccion
const ambiente = 'test'
//

const api_config = {
  local: {
    login: 'http://localhost:8001/api',
    url: 'http://direccion_back/api',
    https: false
  },
  test: {
    login: 'https://login-backend-sm.up.railway.app/api',
    url: 'https://direccion_back/api',
    https: true
  },
  testWifi: {
    url: 'http://192.168.100.5:8000/api',
  },
  produccion: {
    url: '',
  },
  produccionConD: {
    url: '',
  },
}

export const CONFIGS = {
  API_URL: api_config[ambiente].url,
  HTTPS: api_config[ambiente].https,
  LOGIN_URL: api_config[ambiente].login,
  BASE_BACK: "direccion_back"
}

export const updateApiUrl = (selectedUrl) => {
  const HTTPS = CONFIGS.HTTPS ? 'https' : 'http';
  CONFIGS.API_URL = `${HTTPS}://${selectedUrl}/api`;
}

export const concatUrl = (selectedUrl) => {
  const HTTPS = CONFIGS.HTTPS ? 'https' : 'http';
  return `${HTTPS}://${selectedUrl}/api`;
}

